import * as React from 'react';
import { st, classes } from './ThreeDotsLoader.st.css';
import { ThreeDotsLoaderProps } from './types';

/** Animated loader element made from three pulsating dots */
export class ThreeDotsLoader extends React.Component<ThreeDotsLoaderProps> {
  static displayName = 'ThreeDotsLoader';

  render() {
    const { className, isStatic, 'aria-hidden': ariaHidden } = this.props;
    const isAriaHidden = ariaHidden && ariaHidden !== 'false';

    return (
      <div
        data-hook={this.props['data-hook']}
        className={st(classes.root, { static: !!isStatic }, className)}
        aria-hidden={isAriaHidden}
      >
        <div className={classes.dots} />
      </div>
    );
  }
}
